import { Link, useLocation } from "react-router-dom";

const FOOTER_SECTIONS = [
  {
    title: "Products",
    links: [
      { label: "Geminii Space", to: "/space" },
      { label: "Rogue", to: "/space/rogue" },
      { label: "Cerebrum AI", to: "/cerebrum" },
      { label: "Cloud", to: "/cloud" },
    ],
  },
  {
    title: "Rogue Modules",
    links: [
      { label: "SalesFlow", to: "/space/rogue/sales-flow" },
      { label: "Ops", to: "/space/rogue/ops" },
      { label: "Teams", to: "/space/rogue/teams" },
      { label: "Projects", to: "/space/rogue/projects" },
      { label: "Stockroom", to: "/space/rogue/stockroom" },
      { label: "Bookkeep", to: "/space/rogue/bookkeep" },
      { label: "Support", to: "/space/rogue/support" },
      { label: "Connect", to: "/space/rogue/connect" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Pricing", to: "/pricing" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms of Service", to: "/legal/terms" },
      { label: "Privacy Policy", to: "/legal/privacy" },
      { label: "DPA", to: "/legal/dpa" },
    ],
  },
];

const SPACE_PATHS = ["/space", "/space/rogue"];

export default function Footer() {
  const location = useLocation();
  const isSpacePage = SPACE_PATHS.some((p) => location.pathname.startsWith(p));

  return (
    <footer data-testid="footer" className="border-t border-white/[0.06] bg-geminii-deep">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-16">
          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title}>
              <h4 className="font-display font-semibold text-sm text-white mb-5 tracking-wide">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-geminii-dim hover:text-rogue-cyan transition-colors duration-250"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img src="/logos/geminii/all-white.png" alt="Geminii" className="h-5 w-auto opacity-60" />
            <span className="text-xs text-geminii-dim">
              &copy; {new Date().getFullYear()} Geminii. All rights reserved.
            </span>
          </div>

          {isSpacePage && (
            <span
              data-testid="powered-by-space"
              className="text-xs text-rogue-cyan/70 font-medium"
            >
              Powered by Geminii Space
            </span>
          )}
        </div>
      </div>
    </footer>
  );
}
